import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Lightning18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.7398 1.1233L10.8854 6.25H15C15.6164 6.25 15.9707 6.98721 15.5857 7.46852L7.58568 17.4685C7.11466 18.0573 6.13628 17.6204 6.26023 16.8767L7.11469 11.75H3.00003C2.38365 11.75 2.02933 11.0128 2.41438 10.5315L10.4144 0.531478C10.8854 -0.0573052 11.8638 0.379548 11.7398 1.1233ZM4.5605 10.25H8.88538L8.21322 14.2829L13.4396 7.75H9.11469L9.78684 3.71707L4.5605 10.25Z'
      fill='currentColor'
    />
  </Svg>
);

Lightning18.displayName = 'Lightning18';
export default Lightning18;
